import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['sidebarDiv', 'searchInput'];

  toggle() {
    if (this.sidebarDivTarget.classList.contains('hidden')) {
      this.sidebarDivTarget.classList.remove('hidden');
    } else {
      this.sidebarDivTarget.classList.add('hidden');
    }
  }

  outsideClick(e) {
    if (e.target === this.sidebarDivTarget) {
      this.toggle();
    }
  }

  input() {
    const { value } = this.searchInputTarget;

    this.hideGroups(value, joinedGroups);
    this.hideGroups(value, joinableGroups);
    this.hideGroups(value, joinAppliedGroups);
  }

  hideGroups = (value, data) => {
    if (data === null) {
      return true;
    }

    for (let i = 0; i < data.length; i++) {
      const li = $(`#li-${data[i].slug}`);
      li.show();
      const name = data[i].name.toLowerCase();

      if (!name.includes(value)) {
        li.hide();
      }
    }
  };
}
